@if (loading()) {
    <p-skeleton class="w-full h-full" height="7,25rem"></p-skeleton>
} @else {
    @if (disabled()) {
        <div class="w-full h-full p-4 bg-neutral-950 rounded-sm flex flex-col items-center">
            <span class="text-2xl text-muted-color text-center m-auto">{{disabledText() | translate}}</span>
        </div>
    } @else {
        <div class="w-full h-full p-4 bg-neutral-950 rounded-sm flex flex-col">
            <h1 class="text-muted-color">{{title() | translate}}</h1>
            <span class="text-3xl font-bold">{{value()}}</span>
            @if (additionalLinkUrl()) {
                <a class="text-primary underline mt-2" [routerLink]="additionalLinkUrl()">{{additionalLinkTitle() | translate}}</a>
            } @else {
                <span class="text-muted-color mt-2">{{additionalLinkTitle() | translate}}</span>
            }
        </div>
    }
}